import { jsx as s } from "react/jsx-runtime";
import { Slot as g } from "@radix-ui/react-slot";
import A from "react";
const l = (t = {}) => {
  const [e, a] = A.useState(
    (t == null ? void 0 : t.appearanceOverride) || "light"
  ), n = e === "light" ? "dark" : "light", r = { "data-tgph-appearance": e }, c = {
    "data-tgph-appearance": n
  }, o = { "data-tgph-appearance": "light" }, d = { "data-tgph-appearance": "dark" }, u = (p) => {
    document && (a(p), document.documentElement.setAttribute(
      "data-tgph-appearance",
      p
    ));
  };
  return A.useEffect(() => {
    if (!document) return;
    const p = (v) => {
      for (const m of v)
        m.type === "attributes" && m.attributeName === "data-tgph-appearance" && a(
          document.documentElement.getAttribute(
            "data-tgph-appearance"
          )
        );
    }, h = document.documentElement.getAttribute(
      "data-tgph-appearance"
    );
    a(h);
    const i = new MutationObserver(p);
    return i.observe(document.documentElement, { attributes: !0 }), () => {
      i && i.disconnect();
    };
  }, []), {
    setAppearance: u,
    toggleAppearance: () => {
      u(e === "light" ? "dark" : "light");
    },
    appearance: e,
    invertedAppearance: n,
    appearanceProps: r,
    invertedAppearanceProps: c,
    lightAppearanceProps: o,
    darkAppearanceProps: d
  };
}, P = ({
  inverted: t,
  appearance: e,
  asChild: a,
  ...n
}) => {
  const { appearanceProps: r, invertedAppearanceProps: c } = l({
    appearanceOverride: e
  });
  return /* @__PURE__ */ s(a ? g : "div", { ...t ? c : r, ...n });
}, O = ({
  appearance: t,
  asChild: e,
  ...a
}) => {
  const { lightAppearanceProps: n, darkAppearanceProps: r } = l();
  return /* @__PURE__ */ s(e ? g : "div", { ...t === "light" ? n : r, ...a });
}, w = ({
  appearance: t,
  asChild: e,
  ...a
}) => /* @__PURE__ */ s(P, { inverted: !0, appearance: t, asChild: e, ...a });
export {
  P as Appearance,
  w as InvertedAppearance,
  O as OverrideAppearance,
  l as useAppearance
};
//# sourceMappingURL=index.mjs.map
